import { radioGridColsDesktop } from './radioButton.constants';
import { RadioButtonChoice } from './radioButton.types';

export const getRadioChoiceId = (
  adminLabel: string,
  choice: RadioButtonChoice
) => `${adminLabel}_${choice?.value}`;

export const getInputGrid = (layoutGridColumnSpan?: number | string) => {
  layoutGridColumnSpan = Number(layoutGridColumnSpan);
  if (!layoutGridColumnSpan) {
    return radioGridColsDesktop[11];
  }
  return `col-span-12 ${
    radioGridColsDesktop[layoutGridColumnSpan - 1] || radioGridColsDesktop[11]
  }`;
};
